<template>
  <section class="grid-flex column">
    <div class="grid-flex w100 column margin-top-l no-mobile">
      <div class="flex w100 middle">
        <div class="flex-1">
          <div v-if="!loading" class="flex middle">
            <div class="flex-1">
              <h2 class="title-funnel">
                {{ funnel.name }}
              </h2>
            </div>
          </div>
          <div v-else>
            <content-loading>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
        <div class="flex-1 flex end middle">
          <div style="margin-right: 8px; margin-top: 28px">
            <router-link
              :to="{
                name: 'FunnelEdit',
                params: { funnel_id: funnel.id },
              }"
            >
              <div class="button secondary " style="margin-left: 8px">
                EDITAR
              </div>
            </router-link>

            <div
              class="button secondary"
              @click="openToCopy(funnel)"
              style="margin-left: 8px"
            >
              DUPLICAR
            </div>

            <div
              class="button secondary"
              @click="openToDelete(funnel)"
              style="margin-left: 8px"
            >
              DELETAR
            </div>
          </div>
          <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
        </div>
      </div>
      <div  ref="divcontainer" class="flex-1 center-txt w100">
        <div class="box margin-top-l ">
          <div class="box-content custom-card">
            <div v-if="!loadingReport" class="flex row w100">
              <vue-funnel-graph
                v-if="funnelData.values && funnelData.values.length > 0"
                :width="funnelData.width"
                :height="funnelData.height"
                :labels="funnelData.labels"
                :values="funnelData.values"
                :colors="funnelData.colors"
                :sub-labels="funnelData.subLabels"
                :direction="funnelData.direction"
                :gradient-direction="funnelData.gradientDirection"
                :animated="true"
                :display-percentage="true"
              ></vue-funnel-graph>
              <div v-if="isEmptyStep">
                O funil Não tem as etapadas definidas. Crie agora para montar a visualização. 
                <router-link
                    :to="{
                      name: 'FunnelEdit',
                      params: { funnel_id: funnel.id },
                    }"
                  >
                <div class="button secondary">Criar Etapas</div>
                </router-link>
              </div>
            </div>
            <div v-else class="w100">
              <content-loading>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
              </content-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";

import { VueFunnelGraph } from "vue-funnel-graph-js";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import {
  getFunnel,
  getFunnelReport,
} from "@/services/funnel";

export default {
  name: "funnel-detail",
  components: {
    VueFunnelGraph,
    ltkDatePicker,
  },
  props: ['funnel'],
  data() {
    return {
      loading: false,
      loadingReport: false,
      filters: {
        data: {
          date: [
            moment()
              .add(-30, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          search: "",
        },
        list: {},
      },
      stats: {},
      funnelData: {
        labels: [],
        subLabels: [],
        values: [],
        // colors: ["#47265a", "#EC77FF"], // color set for "Add To Cart" segment
        colors: ["#b12031", "#2B2D42"], // color set for "Add To Cart" segment
        direction: "horizontal",
        gradientDirection: "horizontal",
        height: 300,
        width: 1024,
      },
    };
  },
  mounted() {
    //this.getFunnel();
    this.initFilters()
    //this.getFunnelReport();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.getFunnelReport()
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isEmptyStep() {
      return this.funnelData && this.funnelData.labels.length === 0 && !this.loadingReport
    }
  },
  methods: {
    initFilters() {
      let date = this.funnel.custom_filters.date

      var _copyFilterData = Object.assign({}, this.filters.data)

      var _map_date = {
        'DAY': 0,
        'LAST7': -7,
        'LAST14': -14,
        'LAST30': -30,
        'LAST90': -90,
        'LASTMAX': -365,
      }

      var _code_day = _map_date[date] || 0
      var _init_day = 0 
      if (_code_day < 0) {
        _init_day = -1
        _code_day -= 1
      }
      let dateNew = [
            moment()
              .add(_code_day, "d")
              .startOf("day")
              .toDate(),
            moment()
              .add(_init_day, "d")
              .startOf("day")
              .toDate(),
      ]

      _copyFilterData.date = dateNew

      this.filters.data = _copyFilterData
      
    },
    openToDelete(sl) {
      this.$emit('delete', sl)
    },
    openToCopy(sl) {
      this.$emit('copy', sl)
    },
    getFunnel() {
      this.loading = true;
      getFunnel(this.funnel_id)
        .then((result) => {
          this.funnel = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFunnelReport() {
      if (this.loadingReport) {
        return
      }

      this.loadingReport = true;
      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
      };

      getFunnelReport(this.funnel.id, params)
        .then((result) => {
          this.funnelData.labels = result.funnel_data.labels;
          this.funnelData.subLabels = result.funnel_data.subLabels;
          this.funnelData.values = result.funnel_data.values;

          this.stats = result.stats

        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loadingReport = false;
        });
    },
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}

.title-funnel {
  font-weight: 800;
  text-transform: uppercase;
}

</style>
